import { Injectable } from '@angular/core';
import { Effect, Actions, ofType } from '@ngrx/effects';
import { Observable, of, zip } from 'rxjs';
import {
  switchMap,
  map,
  catchError,
  distinctUntilChanged
} from 'rxjs/operators';
import { PreferencesFacade } from '../../facades/preferences.facade';
import { DealService } from '../../services/deal.service';
import { getDefaultDealVersion } from '../../helpers/issue/deal-type';
import { DealActionTypes, Load, LoadSuccess, LoadFail } from './actions';

@Injectable()
export class DealEffects {
  @Effect()
  public loadDeal$: Observable<LoadSuccess | LoadFail> = this.actions$.pipe(
    ofType(DealActionTypes.Load),
    distinctUntilChanged((x: Load, y: Load) => x.payload === y.payload),
    switchMap((action: Load) =>
      zip(
        this.dealService.getDeal(action.payload),
        this.preferencesFacade.preferences$
      ).pipe(
        map(([deal, preferences]) => {
          const defaultVersion = getDefaultDealVersion(
            deal,
            preferences.defaultDealVersions
          );
          return new LoadSuccess({ deal, defaultVersion });
        }),
        catchError((err: Error) => of(new LoadFail(err && err.message)))
      )
    )
  );

  @Effect()
  public reLoadDeal$: Observable<LoadSuccess | LoadFail> = this.actions$.pipe(
    ofType(DealActionTypes.Reload),
    switchMap((action: Load) =>
      zip(
        this.dealService.getDeal(action.payload),
        this.preferencesFacade.preferences$
      ).pipe(
        map(([deal, preferences]) => {
          const defaultVersion = getDefaultDealVersion(
            deal,
            preferences.defaultDealVersions
          );
          return new LoadSuccess({ deal, defaultVersion });
        }),
        catchError((err: Error) => of(new LoadFail(err && err.message)))
      )
    )
  );

  constructor(
    private actions$: Actions,
    private dealService: DealService,
    private preferencesFacade: PreferencesFacade
  ) {}
}
